import React from 'react'
import EmbroideryErrorHeader from './EmbroideryErrorTable/EmbroideryErrorHeader'
import EmbroideryErrorRow from './EmbroideryErrorTable/EmbroideryErrorRow'

function EmbroideryErrorTable(props) {
    const { listEmbroideryError, loading, setType, setBrand, selectedBatchId, selectedAll, onResetSelected, onSelectAll, onUpdateSelectedBatches, reset } = props

    return (
        <div className='EmbroideryErrorTable'>
            <table className='table table-borderless table-striped'>
                <EmbroideryErrorHeader
                    selectedBatchId={selectedBatchId}
                    selectedAll={selectedAll}
                    onResetSelected={onResetSelected}
                    listEmbroideryError={listEmbroideryError}
                    onSelectAll={onSelectAll}
                    reset={reset}
                />
                <tbody className='EmbroideryErrorRow'>
                    {
                        !!listEmbroideryError && listEmbroideryError.map((item, i) => {
                            return <EmbroideryErrorRow
                                key={item._id}
                                index={i}
                                item={item}
                                setType={setType}
                                setBrand={setBrand}
                                selectedBatchId={selectedBatchId}
                                onUpdateSelectedBatches={onUpdateSelectedBatches}
                            />
                        })
                    }
                    {
                        !loading && listEmbroideryError.length === 0 &&
                        <tr>
                            <td colSpan={9}>
                                No result
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    )
}

export default EmbroideryErrorTable